"use strict";
var shouldPureComponentUpdate_1 = require("./shouldPureComponentUpdate");
exports.PureRender = function (target) {
    target.prototype.shouldComponentUpdate = shouldPureComponentUpdate_1.shouldPureComponentUpdate;
};
//# sourceMappingURL=PureRender.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/src/core/react/pure-render/PureRender.js
// module id = 469
// module chunks = 0